/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilesUploaded } from '../../models/files-uploaded';
import { FilesUploadedUpdate } from '../../models/files-uploaded-update';

export interface SaveUploadedFilesApiV2SubmissionsOrgIdFilesPost$Params {
  id: string;
  org: string;
      body: FilesUploadedUpdate
}

export function saveUploadedFilesApiV2SubmissionsOrgIdFilesPost(http: HttpClient, rootUrl: string, params: SaveUploadedFilesApiV2SubmissionsOrgIdFilesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FilesUploaded>>> {
  const rb = new RequestBuilder(rootUrl, saveUploadedFilesApiV2SubmissionsOrgIdFilesPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FilesUploaded>>;
    })
  );
}

saveUploadedFilesApiV2SubmissionsOrgIdFilesPost.PATH = '/api/v2/submissions/{org}/{id}/files';
